import { httpService } from "./http.service";

const BASE_URL = 'upload';
export const uploadService = {
  uploadFile,
  uploadUserImg,
  uploadMemberGroupImg,
  uploadCommentFile,
  uploadPublicFormFile,
  deleteFile,
  uploadFiles,
  deleteCommentReplyFiles,
  deleteOldFiles
};

// async function deleteFile(uuid, accountId) {
//   try {
//     const formData = new FormData();
//     formData.append('accountId', accountId);

//     await httpService.delete(`${BASE_URL}/file/${uuid}`, formData);
//   } catch (error) {
//     console.error('Erro ao deletar o arquivo:', error);
//     throw error;
//   }
// }

async function deleteFile(uuid, accountId) {
  try {
    await httpService.delete(`${BASE_URL}/file/${uuid}?accountId=${accountId}`);
  } catch (error) {
    console.error('Erro ao deletar o arquivo:', error);
    throw error;
  }
}

export async function deleteOldFiles(filesId, accountId, item) {
  try {
    //await httpService.delete(filesId, accountId);
    await httpService.delete(`${BASE_URL}/upload/account/${accountId}/desktopFiles/remove`, { files: filesId, item });
  } catch (error) {
    console.error('Erro ao remover arquivos antigos do desktop:', error);
  }
}

async function uploadFile(file, accountId) {
  const formData = new FormData();
  formData.append('accountId', accountId);
  formData.append('file', file);

  try {
    const response = await httpService.post(`${BASE_URL}/file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return {
      secure_url: response.fileUrl,
      uuid: response.uuid,
      originalName: response.originalName,
    };
  } catch (error) {
    console.error('Erro no upload de arquivo:', error);
    throw error;
  }
}


async function uploadUserImg(file, userId, accountId) {
  const formData = new FormData();

  formData.append('accountId', accountId);
  formData.append('userId', userId)
  formData.append('file', file);

  try {
    const response = await httpService.post(`${BASE_URL}/profile/upload`, formData);

    return {
      secure_url: response.profileImageUrl,
    };
  } catch (error) {
    console.error('Erro no upload de imagem de perfil:', error);
    throw error;
  }
}

async function uploadMemberGroupImg(file, groupId, accountId) {
  const formData = new FormData();

  formData.append('accountId', accountId);
  formData.append('groupId', groupId);
  formData.append('file', file);

  try {
    const response = await httpService.post(`${BASE_URL}/member-group/upload`, formData);

    return {
      secure_url: response.memberGroupImageUrl,
    };
  } catch (error) {
    console.error('Erro no upload de imagem do grupo:', error);
    throw error;
  }
}

async function uploadCommentFile({ boardId, groupId, taskId, file, accountId }) {
  try {
    const formData = new FormData();
    formData.append("accountId", accountId);
    formData.append("file", file);
    formData.append("boardId", boardId);
    formData.append("groupId", groupId);
    formData.append("taskId", taskId);

    const response = await httpService.post(`${BASE_URL}/upload/comment`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    return response;
  } catch (err) {
    console.error("Erro ao subir arquivo de comentário:", err);
    throw err;
  }
}

async function uploadFiles(file, accountId, item) {
  const formData = new FormData();

  formData.append('accountId', accountId);
  //formData.append('desktopId', desktopId);
  formData.append('item', item);
  formData.append('file', file);

  try {
    const response = await httpService.post(`${BASE_URL}/upload/avatarWallpaper`, formData);

    return {
      secure_url: response.fileUrl,
      uuid: response.uuid,
      originalName: response.originalName,
    };
  } catch (error) {
    console.error('Erro ao subir imagem:', error);
    throw error;
  }
}

export async function deleteCommentReplyFiles(accountId, uuids) {
  try {
    await httpService.post(`${BASE_URL}/account/${accountId}/commentReplyFiles/remove`, { uuids });
  } catch (error) {
    console.error('Erro ao deletar o arquivo:', error);
    throw error;
  }
}

function splitPageName(pageName) {
  const [prefix, slug] = String(pageName || "").split("/");
  if (!prefix || !slug) {
    throw new Error("pageName inválido. Esperado: 'prefix/slug'");
  }
  return { prefix, slug };
}

async function uploadPublicFormFile(file, pageName) {
  const { prefix, slug } = splitPageName(pageName);
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await httpService.post(`public/forms/${prefix}/${slug}/files`, formData);

    return {
      secure_url: response.fileUrl,
      uuid: response.uuid,
      originalName: response.originalName,
    };
  } catch (error) {
    console.error('Erro no upload público de formulário:', error);
    throw error;
  }
}
